'use client'

import { Link } from '@/components/link'
import { Section } from '@/components/section'
import { Button } from '@/components/ui/button'
import BenchedLogo from './benched-logo'

const description = 'AI benchmarking and analysis'

export type AboutContentProps = {
  onClose?: () => void
}

const AboutContent = ({ onClose }: AboutContentProps) => (
  <>
    <Section className="gap-4 flex items-start">
      <BenchedLogo size={48} />
      <div>
        <h1>Benched.ai</h1>
        <p className="text-foreground-lighter">{description}</p>
      </div>
    </Section>
    <Section>
      <p>Living library of companies, models, and people building AI</p>
      <p>
        Powered by our{' '}
        <Link onClick={onClose} href="/methodology">
          open evaluation methodology
        </Link>
      </p>
      {/**
      
       */}
      <p>The best model is always changing &mdash; stay updated</p>
    </Section>
    <Section delay={0.2}>
      {/**
      <h2>Support project</h2>
      <p>
        You can support the project with a $5 monthly donation. Cancel at any
        time.
      </p>
      */}
      <Button asChild className="mt-4 inline-block">
        <Link href="https://buy.polar.sh/polar_cl_INfm97n1Kq1FKgZ3d81qg8B7dFZMHv5a1IKPz2SinL3">
          Support
        </Link>
      </Button>
    </Section>
  </>
)

export default AboutContent
